/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BlogManagerNextArticleResponse } from "./BlogManagerNextArticleResponse";

export type BlogManagerNextArticleResponseApiRespoonse = {
  data?: BlogManagerNextArticleResponse;
  status?: BlogManagerNextArticleResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace BlogManagerNextArticleResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
